// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1T6lk","rootSmall":"AddTileButton_rootSmall__3O4uY"};